import { Pipe, PipeTransform } from '@angular/core';
import {DecimalPipe} from "@angular/common";
import {CONSTANTS} from "../../../constants/constants";

@Pipe({
  name: 'price'
})
export class PricePipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) {
  }

  transform(value: string | number, unit: string = CONSTANTS.DEFAULT_CURRENCY, digits = '2'): string {
    if(!value && value !== '0' && value !== 0) {
      return '';
    }
    let result = this.decimalPipe.transform(value, `1.${digits}-${digits}`);
    if(unit === 'EUR') {
      unit = '€';
    }
    return `${result} ${unit}`;
  }

}
